__turbopack_context__.v({
  "badge": "index-module__HT2Joq__badge",
  "default": "index-module__HT2Joq__default",
  "error": "index-module__HT2Joq__error",
  "icon": "index-module__HT2Joq__icon",
  "info": "index-module__HT2Joq__info",
  "message": "index-module__HT2Joq__message",
  "neutral": "index-module__HT2Joq__neutral",
  "warning": "index-module__HT2Joq__warning",
  "wrapper": "index-module__HT2Joq__wrapper",
});
